import { useLocation } from "react-router-dom";
import AddressSelector from "../AddressSelector/AddressSelector.jsx";
import ControlBar from "../ControlBar/ControlBar.jsx";
import Logo from "../Logo/Logo.jsx";
import DateSelector from "./DateSelector/DateSelector.jsx";
import css from "./Header.module.css";
import { useCan } from "../../utils/permissions.js";

export default function Header() {
  const location = useLocation();
  const isCrmPage = location.pathname === "/crm";
  const headerOnLogin = location.pathname === "/login";
  const headerOnRegister = location.pathname === "/register";
  const headerOnRegisterForm = location.pathname === "/registration-form";
  const headerOnMain = location.pathname === "/";
  const sideBarOnThanksForRegistration =
    location.pathname === "/thanks-for-registration";

  const can = useCan();

  if (
    headerOnLogin ||
    headerOnRegister ||
    headerOnMain ||
    headerOnRegisterForm ||
    sideBarOnThanksForRegistration
  ) {
    return null; // не відображати Header
  }

  return (
    <div className={css.header}>
      <div className={css.leftSideWrapper}>
        <Logo />
        {can("workshops", "read") && <AddressSelector />}
      </div>
      {isCrmPage && <DateSelector />}
      <ControlBar />
    </div>
  );
}
